<div class="flex flex-col gap-5 rounded-2xl p-6 transition-all">
  <div class="flex flex-col gap-3">
    <h3
      class="textPrimaryColor text-sm"
      [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'"
      i18n="@@attr.button.importGlobal">
      Import Global Attribute
    </h3>
    <div>
      <button
        (click)="onImportClick.emit()"
        [disabled]="isEditMode"
        class="cursor-pointer rounded-xl bg-gray-800 text-sm text-white shadow-sm transition-all hover:bg-gray-900 disabled:opacity-40"
        [ngClass]="productType() === 'edit' ? 'px-5 py-1.5 font-medium' : 'px-6 py-2.5 font-bold'"
        i18n="@@attr.button.importGlobal">
        Import Global Attribute
      </button>
    </div>
  </div>

  <hr class="borderhelperColorOne" />

  <form [formGroup]="attributeForm" (ngSubmit)="handleSubmit()" class="flex flex-col gap-5">
    @if (isEditMode) {
      <h3
        class="textPrimaryColor text-sm"
        [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'"
        i18n="@@attr.step.editTitle">
        Edit Attribute Title
      </h3>
    } @else {
      <h3
        class="textPrimaryColor text-sm"
        [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'"
        i18n="@@attr.step.title">
        Define Attributes
      </h3>
    }

    <div class="grid grid-cols-1 items-start gap-4 md:grid-cols-2">
      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-gray-700" [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'">
          <span i18n="@@attr.field.titleEn">Attribute Title (English)</span>
        </label>
        <input
          type="text"
          formControlName="titleEn"
          i18n-placeholder="@@attr.placeholder.titleEn"
          placeholder="Enter attribute title (English, optional)"
          class="borderPlaceholderColor focus:borderPrimaryColor w-full rounded-xl border bg-white p-3 text-sm text-gray-800 transition-all outline-none"
          [class.bordererrorcolor]="attributeForm.get('titleEn')?.invalid && attributeForm.get('titleEn')?.touched" />

        @if (attributeForm.get("titleEn")?.touched && attributeForm.get("titleEn")?.errors) {
          <span class="errortextcolor text-xs font-medium">
            @if (attributeForm.get("titleEn")?.hasError("englishOnly")) {
              <ng-container i18n="@@attr.validation.onlyEnglish">Please enter English characters only</ng-container>
            }
            @if (attributeForm.get("titleEn")?.hasError("alreadyExists")) {
              <ng-container i18n="@@attr.validation.titleAlreadyExists">This attribute already exists</ng-container>
            }
          </span>
        }
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm text-gray-700" [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'">
          <span i18n="@@attr.field.titleAr">Attribute Title (Arabic)</span>
          <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          formControlName="titleAr"
          i18n-placeholder="@@attr.placeholder.titleAr"
          placeholder="Enter attribute title (Arabic)"
          class="borderPlaceholderColor focus:borderPrimaryColor w-full rounded-xl border bg-white p-3 text-sm text-gray-800 transition-all outline-none"
          [class.bordererrorcolor]="attributeForm.get('titleAr')?.invalid && attributeForm.get('titleAr')?.touched" />

        @if (attributeForm.get("titleAr")?.touched && attributeForm.get("titleAr")?.errors) {
          <span class="text-xs font-medium text-red-500">
            @if (attributeForm.get("titleAr")?.hasError("required")) {
              <ng-container i18n="@@attr.validation.titleArRequired">Arabic attribute title is required</ng-container>
            } @else if (attributeForm.get("titleAr")?.hasError("arabicOnly")) {
              <ng-container i18n="@@attr.validation.onlyArabic">Please enter Arabic characters only</ng-container>
            }
          </span>
        }
      </div>
    </div>

    <div class="flex justify-end gap-3">
      @if (isEditMode) {
        <button
          type="button"
          (click)="handleCancel()"
          [ngClass]="productType() === 'edit' ? 'px-5 py-1.5 font-medium' : 'px-6 py-2.5 font-bold'"
          class="cursor-pointer rounded-xl border border-gray-200 text-sm text-gray-500 transition-all hover:bg-gray-50"
          i18n="@@product.button.cancel">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="attributeForm.invalid"
          [ngClass]="productType() === 'edit' ? 'px-5 py-1.5 font-medium' : 'px-6 py-2.5 font-bold'"
          class="bgPrimaryColor bgHoverPrimaryColor cursor-pointer rounded-xl text-sm text-white shadow-md transition-all disabled:opacity-50"
          i18n="@@attr.button.saveEdit">
          Save Changes
        </button>
      } @else {
        <button
          type="submit"
          [disabled]="attributeForm.invalid"
          [ngClass]="productType() === 'edit' ? 'px-5 py-1.5 font-medium' : 'px-6 py-2.5 font-bold'"
          class="bgPrimaryColor bgHoverPrimaryColor cursor-pointer rounded-xl text-sm text-white shadow-md transition-all disabled:opacity-50"
          i18n="@@attr.button.addAttribute">
          + Add Attribute
        </button>
      }
    </div>
  </form>
</div>
